import { Stack, Typography, type StackProps } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React from "react";

type Props = StackProps & {
  icon?: React.ReactNode;
  title: string;
  children?: React.ReactNode;
};

export function Tip(props: Props) {
  const { icon = <InfoOutlinedIcon color="primary" fontSize="large" />, title, children, ...stackProps } = props;

  return (
    <Stack spacing={2} alignItems="center" justifyContent="center" height="100%" {...stackProps}>
      {icon}
      <Typography variant="h2">{title}</Typography>
      {children}
    </Stack>
  );
}
